<app-layout></app-layout>

<app-cgu-cookie-container template="MAIN"></app-cgu-cookie-container>